import axios from 'axios'
import { encryptStorage } from 'src/Util'
//import { documentsAPI, tasksAPI,fixFileApi } from '../api'
//import { documentsAPI, fileDownloadAPI, tasksAPI,fixFileApi } from '../apiLocal'
// import {  documentDetailAPI } from '../apiLocal'
import {
  documentsAPI,
  documentDetailAPI,
  fileDownloadAPI,
  tasksAPI,
  fixFileApi,
  ftpSftpConfigAPI,
  usersAPI,
} from '../api'
// import { documentsAPI,documentDetailAPI, fileDownloadAPI, tasksAPI,fixFileApi } from '../api.dev'
//Action Types
export const MYDOCUMENTS_ALL = 'MYDOCUMENTS_ALL'
export const MYDOCUMENTS_COMPLETED = 'MYDOCUMENTS_COMPLETED'
export const MYDOCUMENTS_ASSIGNEDTOME = 'MYDOCUMENTS_ASSIGNEDTOME'
export const MYDOCUMENTS_ASSIGNEDTOOTHERS = 'MYDOCUMENTS_ASSIGNEDTOOTHERS'
export const MYDOCUMENTS_ERROR = 'MYDOCUMENTS_ERROR'
export const MYDOCUMENTS_WIP = 'MYDOCUMENTS_WIP'
export const VALIDATIONSTANDARD_WIP = 'VALIDATIONSTANDARD_WIP'
export const UPDATE_VALIDATIONSTANDARD_WIP = 'UPDATE_VALIDATIONSTANDARD_WIP'
export const MYDOCUMENTS_MOVETOWIP = 'MYDOCUMENTS_MOVETOWIP'

export const MYDOCUMENTS_DOWNLOADCOMP_INI = 'MYDOCUMENTS_DOWNLOADCOMP_INI'
export const MYDOCUMENTS_DOWNLOADCOMP = 'MYDOCUMENTS_DOWNLOADCOMP'
export const MYDOCUMENTS_DOWNLOADCOMP_FAILED = 'MYDOCUMENTS_DOWNLOADCOMP_FAILED'

export const MYDOCUMENTS_UPLOADCOMP_INI = 'MYDOCUMENTS_UPLOADCOMP_INI'
export const MYDOCUMENTS_UPLOADCOMP = 'MYDOCUMENTS_UPLOADCOMP'
export const MYDOCUMENTS_UPLOADCOMP_FAILED = 'MYDOCUMENTS_UPLOADCOMP_FAILED'
export const MYDOCUMENTS_UPLOADFILEUPDATE = 'MYDOCUMENTS_UPLOADFILEUPDATE'

export const MYDOCUMENTS_ACCEPTORREJECT = 'MYDOCUMENTS_ACCEPTORREJECT'
export const MYDOCUMENTS_GETASSIGNLIST = 'MYDOCUMENTS_GETASSIGNLIST'
export const MYDOCUMENTS_REASSIGN = 'MYDOCUMENTS_REASSIGN'
export const MYDOCUMENTS_REASSIGN_CLEAR = 'MYDOCUMENTS_REASSIGN_CLEAR'
export const MYDOCUMENTS_REVOKE = 'MYDOCUMENTS_REVOKE'
export const MYDOCUMENTS_DELERROR = 'MYDOCUMENTS_DELERROR'
export const GET_COMPANY_TAGS = 'GET_COMPANY_TAGS'
export const GET_TOP_ISSUES = 'GET_TOP_ISSUES'
export const GET_FILE_HISTORY = 'GET_FILE_HISTORY'
export const VIEW_SUMMARY_LINK = 'VIEW_SUMMARY_LINK'
export const INSERT_TAG = 'INSERT_TAG'
export const APPLY_TAG = 'APPLY_TAG'
export const CHECK_FIX_OPR = 'CHECK_FIX_OPR'
export const RESET_CHECK_FIX_OPR = 'RESET_CHECK_FIX_OPR'
export const FILE_UPDATE = 'FILE_UPDATE'
export const FILE_UPDATE_CLEAR = 'FILE_UPDATE_CLEAR'

export const FILE_DELETE = 'FILE_DELETE'
export const FILE_DELETE_CLEAR = 'FILE_DELETE_CLEAR'

export const FILE_UPLOAD_VERIFY = 'FILE_UPLOAD_VERIFY'
export const MYDOCUMENTS_SHARE = 'MYDOCUMENTS_SHARE'
export const GET_S2_LINK = 'GET_S2_LINK'

export const UPDATED_FILE = 'UPDATED_FILE'
export const RESET_SHARE_DATA = 'RESET_SHARE_DATA'
export const RESET_TAG_DATA = 'RESET_TAG_DATA'
export const MYDOCUMENT_MOVETOWIP_CLEAR = 'MYDOCUMENT_MOVETOWIP_CLEAR'

export const MYDOCUMENTS_FILE_DELETE_CLEAR = 'MYDOCUMENTS_FILE_DELETE_CLEAR'

export const USER_NOTIFICATION = 'USER_NOTIFICATION'
export const TEST_CONNECTION = 'TEST_CONNECTION'
export const GET_FTP_SFTP_CONFIG = 'GET_FTP_SFTP_CONFIG'
export const ADD_FTP_SFTP_CONFIG = 'ADD_FTP_SFTP_CONFIG'
export const UPDATE_FTP_SFTP_CONFIG = 'UPDATE_FTP_SFTP_CONFIG'
export const REMOVE_TOASTER_MSG = 'REMOVE_TOASTER_MSG'
export const SHOW_FTP_SFTP_LOADER = 'SHOW_FTP_SFTP_LOADER'
export const ADD_UPLOADED_FILES = 'ADD_UPLOADED_FILES'
export const UPDATE_UPLOAD_PROGRESS = 'UPDATE_UPLOAD_PROGRESS'
export const CLEAR_UPLOAD_PROGRESS = 'CLEAR_UPLOAD_PROGRESS'

export const MYDOC_CURRENT_TAB = 'MYDOC_CURRENT_TAB'

export const LICENSE_CONSUMPTION_SUCCESS = 'LICENSE_CONSUMPTION_SUCCESS'
export const LICENSE_CONSUMPTION_FAILURE = 'LICENSE_CONSUMPTION_FAILURE'
export const LICENSE_MESSAGE_CLEAR = 'LICENSE_MESSAGE_CLEAR'
export const CHECK_FIX_OPR_FAIL = 'CHECK_FIX_OPR_FAIL'
export const CHECK_FIX_OPR_FAIL_CLEAR = 'CHECK_FIX_OPR_FAIL_CLEAR'
export const LICENSE_CONSUMPTION_REVIEW_FAILURE = 'LICENSE_CONSUMPTION_REVIEW_FAILURE'
export const LICENSE_CONSUMPTION_REVIEW_FAILURE_CLEAR = 'LICENSE_CONSUMPTION_REVIEW_FAILURE_CLEAR'


export const activeTab = (tabValue) => (dispatch) => {
  dispatch({
    type: MYDOC_CURRENT_TAB,
    payload: tabValue,
  })
}

//Action Creators
export const myDocsAll = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  searchObj.userId = userDetail.user_id
  documentsAPI.post('/document/files-search', searchObj).then((myDocsAllResponse) => {
    dispatch({
      type: MYDOCUMENTS_ALL,
      payload: myDocsAllResponse.data,
    })
  })
}
export const myDocsComp = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  searchObj.userId = userDetail.user_id
  documentsAPI.post('/document/files-search', searchObj).then((myDocsCompResponse) => {
    dispatch({
      type: MYDOCUMENTS_COMPLETED,
      payload: myDocsCompResponse.data,
    })
  })
}

export const myDocsAssignedMe = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  searchObj.userId = userDetail.user_id
  documentsAPI.post('/document/files-search', searchObj).then((myDocsAssignMeResponse) => {
    dispatch({
      type: MYDOCUMENTS_ASSIGNEDTOME,
      payload: myDocsAssignMeResponse.data,
    })
  })
}
export const myDocsAssignedOthers = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  searchObj.userId = userDetail.user_id
  documentsAPI.post('/document/files-search', searchObj).then((myDocsAssignOthersResponse) => {
    dispatch({
      type: MYDOCUMENTS_ASSIGNEDTOOTHERS,
      payload: myDocsAssignOthersResponse.data,
    })
  })
}

export const myDocsError = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  searchObj.userId = userDetail.user_id
  documentsAPI.post('/document/files-search', searchObj).then((myDocserrorResponse) => {
    dispatch({
      type: MYDOCUMENTS_ERROR,
      payload: myDocserrorResponse.data,
    })
  })
}

//export const myDocsWip = (filterFormatArray,filterTagArray,page,searchterm,sortBy, sortOrder,dateRange) => (dispatch) => {
export const myDocsWip = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  console.log('searchObj', searchObj)
  searchObj.userId = userDetail.user_id
  documentsAPI.post('/document/files-search', searchObj).then((myDocswipResponse) => {
    console.log('mydocwipRespose', myDocswipResponse)
    dispatch({
      type: MYDOCUMENTS_WIP,
      payload: myDocswipResponse.data,
    })
  })
}

export const getValidationStandardWip = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    company_id: 337,
    user_id: userDetail.user_id,
  }
  fixFileApi.post('/fix/get-file-validation-standard', data).then((validationStandardResponse) => {
    dispatch({
      type: VALIDATIONSTANDARD_WIP,
      payload: validationStandardResponse.data,
    })
  })
}

export const updateValidationStandardWip = (standardPayload) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  standardPayload.user_id = userDetail.user_id
  fixFileApi
    .post('/fix/update-file-validation-standard', standardPayload)
    .then((validationStandardResponse) => {
      dispatch({
        type: UPDATE_VALIDATIONSTANDARD_WIP,
        payload: validationStandardResponse.data,
      })
      dispatch(getValidationStandardWip())
    })
}
/*************Modal************ */
export const movetoWip = (document) => (dispatch) => {
  console.log('movetoWip==ddddddddddddddddddddddd===>', document)
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    // user_id: `${userDetail.user_id}`,
    // company_id: `${userDetail.company_id}`,
    //"userId":userDetail.user_id

    fileId: document.fileId,
    stage: 'WIP',
    statusId: 2,
  }

  documentsAPI.put('/document/files', data).then((movetowipResponse) => {
    dispatch({
      type: MYDOCUMENTS_MOVETOWIP,
      payload: movetowipResponse.data,
    })
  })
}

export const fileDownloadIni = () => {
  return {
    type: MYDOCUMENTS_DOWNLOADCOMP_INI,
  }
}

export const fileDownloadSuccess = (downloadCompResponse) => {
  return {
    type: MYDOCUMENTS_DOWNLOADCOMP,
    payload: downloadCompResponse.data,
  }
}

export const fileDownloadFailure = (error) => {
  return {
    type: MYDOCUMENTS_DOWNLOADCOMP_FAILED,
    payload: error,
  }
}
export const downloadComp = (downloadDetail) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    destinationPath: '1422/8b0d7041-1e2c-4890-95fe-b9a6b4bf1736/source/sample_protected_new.pdf',
    //"destinationPath":path,
    s3_version_id: '',
    companyId: userDetail.company_id,
    userid: `${userDetail.user_id}`,
  }
  return (dispatch) => {
    dispatch(fileDownloadIni())
    tasksAPI
      .post('/task/file/downloadForUser', data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Tenant': 'ai',
        },
      })
      .then((res) => {
        window.open(response.data.data, '_blank')
        console.log('fileDownload detail', res)
        dispatch(fileDownloadSuccess(res))
      })
      .catch((error) => {
        dispatch(fileDownloadFailure(error))
      })
  }
}

export const fileAcceptOrReject = (document, action) => (dispatch) => {
  console.log('document==>', document)
  console.log('action---------------==>', action)
  const userDetail = encryptStorage.getItem('session-user')
  // console.log("userDetail==>",userDetail)

  const data = {
    // user_id: `${userDetail.user_id}`,
    // company_id: `${userDetail.company_id}`,
    //"userId":userDetail.user_id

    action: action,
    shareId: document.shareId,
    companyId: userDetail.company_id,
    userid: `${userDetail.user_id}`,
  }
  documentsAPI
    .post('/document/share/' + document.shareId + '/' + action, data)
    .then((fileAcceptOrRjectResponse) => {
      dispatch({
        type: MYDOCUMENTS_ACCEPTORREJECT,
        payload: fileAcceptOrRjectResponse.data,
      })
    })
}

export const getAssignList = (fileId) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI
    .get(
      '/document/file/' +
        `${fileId}` +
        '/not-assigned-users?companyId=' +
        `${userDetail.company_id}`,
    )
    .then((getassignlistResponse) => {
      console.log('getassignlistResponse.data11111>', fileId)

      // documentsAPI.get('/document/file/482/not-assigned-users?companyId=337').then((getassignlistResponse) => {
      console.log('getassignlistResponse.data==5555555555555========>', getassignlistResponse.data)

      dispatch({
        type: MYDOCUMENTS_GETASSIGNLIST,
        payload: getassignlistResponse.data,
      })
    })
}

export const reAssignOthers = (formData) => (dispatch) => {
  console.log('dreAssignOthers')
  try {
    const userDetail = encryptStorage.getItem('session-user')
    const data = {
      fileId: formData.fileId,
      shareID: formData.shareId,
      permission: formData.taskAssigned,
      userid: formData.userid,
      createdby: userDetail.user_id,
    }
    console.log('data==>5555555555555', data)
    documentsAPI
      .post('/document/file/' + data.fileId + '/share/' + data.shareID, data)
      .then((reassignOthersResponse) => {
        console.log('', reassignOthersResponse.data)
        dispatch({
          type: MYDOCUMENTS_REASSIGN,
          payload: reassignOthersResponse.data,
        })
      })
  } catch (err) {
    console.log('err----', err)
  }
}

export const revokeOthers = (formData) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    userid: `${userDetail.user_id}`,
    companyId: userDetail.company_id,
  }
  documentsAPI.delete('/document/share/' + formData.shareId, data).then((revokeOthersResponse) => {
    console.log('data res', revokeOthersResponse.data)
    dispatch({
      type: MYDOCUMENTS_REVOKE,
      payload: revokeOthersResponse.data,
    })
  })
}

export const delError = (formData) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    companyId: userDetail.company_id,
  }
  documentsAPI
    .delete('/document/users/' + `${userDetail.user_id}` + '/files/' + formData.fileId, data)
    .then((delErrorResponse) => {
      console.log('resss =>', delErrorResponse.data)
      dispatch({
        type: MYDOCUMENTS_DELERROR,
        payload: delErrorResponse.data,
      })
    })
}

export const allShare = (formData) => (dispatch) => {
  console.log('Share')
  try {
    const userDetail = encryptStorage.getItem('session-user')
    const data = {
      fileId: formData.fileId,
      permission: formData.taskAssigned,
      userid: formData.userid,
      createdby: userDetail.user_id,
    }
    console.log('data==>', data)
    documentsAPI
      .post('/document/file/' + data.fileId + '/share/', data)
      .then((allShareResponse) => {
        console.log('', allShareResponse.data)
        dispatch({
          type: MYDOCUMENTS_SHARE,
          payload: allShareResponse.data,
        })
      })
  } catch (err) {
    console.log('err----', err)
  }
}

// Detail view popup API's

export const getTags = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI.get(`/document/company/${userDetail.company_id}/tags`).then((response) => {
    dispatch({
      type: GET_COMPANY_TAGS,
      payload: response.data,
    })
  })
}

export const getFileTopIssues = (fileId) => (dispatch) => {
  console.log('File id for Top issues ::', fileId)
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI.get(`/document/file/${fileId}/top-issues`).then((response) => {
    dispatch({
      type: GET_TOP_ISSUES,
      payload: response.data,
    })
  })
}

export const getFileHistory = (fileId, orderBy) => (dispatch) => {
  console.log('File id for Top issues ::', fileId)
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI
    .get(`/document/file/${fileId}/histories/user/${userDetail.user_id}?orderBy=${orderBy}`)
    .then((response) => {
      dispatch({
        type: GET_FILE_HISTORY,
        payload: response.data,
      })
    })
}

export const fileHistoryDownload = (downloadDetails) => (dispatch) => {
  console.log('fileHistoryDownload ::', downloadDetails)
  const userDetail = encryptStorage.getItem('session-user')
  downloadDetails.company_id = userDetail.company_id
  downloadDetails.user_id = userDetail.user_id
  tasksAPI.post(`/task/file/downloadForUser`, downloadDetails).then((response) => {
    console.log('fileHistoryDownload ::: ', response.data)
    window.open(response.data.data, '_blank')
    // dispatch({
    //   type: GET_DOWNLOAD_LINK,
    //   payload: response.data,
    // })
  })
}

export const fileHistorySummary = (path, version) => (dispatch) => {
  console.log('fileHistoryDownload ::', path)
  const userDetail = encryptStorage.getItem('session-user')
  let downloadDetails = {
    company_id: userDetail.company_id,
    user_id: userDetail.user_id,
    type: 's3',
    destinationPath: path,
    s3_version_id: version,
  }
  tasksAPI.post(`/task/file/viewForUser`, downloadDetails).then((response) => {
    console.log('fileHistoryDownload ::: ', response.data)
    dispatch({
      type: VIEW_SUMMARY_LINK,
      payload: response.data,
    })
  })
}

export const insertCompanyTag = (tagName) => (dispatch) => {
  console.log('Tagname ::', tagName)
  const userDetail = encryptStorage.getItem('session-user')
  let tagDetails = {
    companyId: userDetail.company_id,
    createdBy: userDetail.user_id,
    tagName: tagName,
  }
  documentsAPI.post(`/document/tags`, tagDetails).then((response) => {
    console.log('Insert Tag ::: ', response.data)
    dispatch({
      type: INSERT_TAG,
      payload: response.data,
    })
  })
}

export const addFileTag = (fileId, tagId) => (dispatch) => {
  console.log('Tagname ::', tagId)
  const userDetail = encryptStorage.getItem('session-user')
  let tagDetails = {
    companyId: userDetail.company_id,
    user_id: userDetail.user_id,
    tagId: tagId,
    fileId: fileId,
  }
  documentsAPI
    .post(`/document/users/${userDetail.user_id}/files/${fileId}/tags/${tagId}`, tagDetails)
    .then((response) => {
      let data = response.data

      dispatch({
        type: APPLY_TAG,
        payload: { data, fileId },
      })
    })
}




export const checkOrFix = (fileDetails, operation) => async(dispatch) => {
  console.log('Invoked  ::', operation)
  console.log('fileDetails  ::', fileDetails)

  var s3Path = fileDetails.s3Path

  if (
    fileDetails.format.toLowerCase() == 'pdf' &&
    (fileDetails.fixCompleted || fileDetails.reviewCompleted)
  ) {
    s3Path = s3Path.replace('/source', '/output')
  }

  const userDetail = encryptStorage.getItem('session-user')
  let checkFFixOpr = {
    companyId: userDetail.company_id,
    user_id: userDetail.user_id,
    id: fileDetails.fileId,
    fileName: fileDetails.fileName,
    s3path: s3Path,
    service_name: operation,
  }
  if(operation == 'ocr'){
    checkFFixOpr.performOCR=true;
    checkFFixOpr.service_name= 'fix';
  }
  // fixFileApi.post(`/fix/Accessibilitycheckorfix`, checkFFixOpr).then((response) => {
  //   let data = response.data.data

  //   dispatch({
  //     type: CHECK_FIX_OPR,
  //     payload: { data, operation, fileId: fileDetails.fileId },
  //   })
  // })

   const checkFixRes = await fixFileApi.post(`/fix/Accessibilitycheckorfix`, checkFFixOpr)
  // const checkFixRes = await axios.post(`http://localhost:9111/fix/Accessibilitycheckorfix`, checkFFixOpr)

  if(checkFixRes.data.success) {
    
    let data = checkFixRes.data
    // let data = checkFixRes.data.data

    dispatch({
      type: CHECK_FIX_OPR,
      payload: { data, operation, fileId: fileDetails.fileId },
    })
  }else {
    console.log("CHECKFIX FAIL RES", checkFixRes)
    checkFixRes.data.selectedFileId = fileDetails.fileId;

    dispatch({
        type: CHECK_FIX_OPR_FAIL,
        payload:checkFixRes.data,
      })
  }

}

export const gotoDocEditor = (doc) => {
  let userDetail = encryptStorage.getItem('session-user')
  let taskAssigned = 'All_TASKS'
  let shareID = 0
  let userFile = doc.assignedFiles.filter((x) => x.assignedToEmail == userDetail.email_id)
  if (userFile.length > 0) {
    shareID = userFile[0].shareId
    taskAssigned =
      userFile[0].taskAssigned.toLowerCase() == 'alt-text'
        ? 'Alt_text_TASKS'
        : userFile[0].taskAssigned.toLowerCase() == 'tagging'
        ? 'Tagging_TASKS'
        : 'All_TASKS'
  }
console.log("docStatus::", doc)
  encryptStorage.setItem('file_id_' + doc.fileId, doc.fileId)
  encryptStorage.setItem('task_id_' + doc.fileId, doc.fileId)
  encryptStorage.setItem('docType_' + doc.fileId, 'pdf')
  encryptStorage.setItem('project_details_id_' + doc.fileId, 10)
  encryptStorage.setItem('filename_' + doc.fileId, doc.fileName)
  encryptStorage.setItem('userID_' + doc.fileId, doc.createdBy)
  encryptStorage.setItem('project_id_' + doc.fileId, 0)
  encryptStorage.setItem('serviceId_' + doc.fileId, 41)
  encryptStorage.setItem('project_category_type_id_' + doc.fileId, 10)
  encryptStorage.setItem('viewerType_' + doc.fileId, 'pdf')
  encryptStorage.setItem('output_log_file_id' + doc.fileId, doc.outputLogPath)
  encryptStorage.setItem('random_id' + doc.fileId, doc.randomId)

  encryptStorage.setItem('editorPermisson_' + doc.fileId, taskAssigned)
  encryptStorage.setItem('shareID_' + doc.fileId, shareID)

  encryptStorage.setItem('isOriginalUser_' + doc.fileId, userDetail.user_id === doc.createdBy)
  encryptStorage.setItem('s3_path_' + doc.fileId, doc.s3Path)
  encryptStorage.setItem('statusID_' + doc?.fileId, doc?.statusId)

  console.log('file Info', doc)
  
  if (!doc?.permissions?.jsonReview) {
    let loading = {}
    loading[doc.fileId] = true
    // this.setState({ showLoader: loading })
    encryptStorage.setItem('editor_loaderMessage', 'The document is being prepared kindly wait.')
    fixFileApi
      .post(`/fix/Accessibilityreview`, {
        id: doc.fileId,
        createdby: userDetail.user_id,
      })
      .then((response) => {
        let loading = {}
        loading[doc.fileId] = false
        // this.setState({ showLoader: loading })
        window.open('/#/editor/' + doc.fileId, '_blank')
      })
  } else {
    encryptStorage.setItem(
      'editor_loaderMessage',
      'Please wait while the document is processed by our AI engine.',
    )
    window.open('/#/editor/' + doc.fileId, '_blank')
  }
}


export const resetCheckOrFix = (fileDetails, operation) => (dispatch) => {
  dispatch({
    type: RESET_CHECK_FIX_OPR,
  })
}

export const fileUpdate = (fileId, statusId, stage) => (dispatch) => {
  console.log('Invoked  ::', stage)
  const userDetail = encryptStorage.getItem('session-user')
  let checkFFixOpr = {
    companyId: userDetail.company_id,
    createdBy: userDetail.user_id,
    fileId: fileId,
    statusId: statusId,
    stage: stage,
  }

  documentsAPI.put(`/document/files`, checkFFixOpr).then((response) => {
    let data = response.data.data

    dispatch({
      type: FILE_UPDATE,
      payload: { data, operation: stage },
    })
  })
}

export const proceedWithOutOCR = (fileId, statusId, stage) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  let proceedWithOutOCRReq = {
    companyId: userDetail.company_id,
    createdBy: userDetail.user_id,
    fileId: fileId,
    statusId: statusId,
    stage: stage,
  }

  documentsAPI.put(`/document/files`, proceedWithOutOCRReq).then((response) => {
    let data = response.data.data

    dispatch({
      type: FILE_UPDATE,
      payload: { data, operation: stage },
    })
  })
}

export const fileUpdateReview = (fileId, statusId, stage) => (dispatch) => {
  console.log('Invoked  ::', stage)
  const userDetail = encryptStorage.getItem('session-user')
  let checkFFixOpr = {
    companyId: userDetail.company_id,
    createdBy: userDetail.user_id,
    fileId: fileId,
    statusId: statusId,
    stage: stage,
  }

  return new Promise( async(resolve, reject) => {
    try {
      const response = await documentsAPI.put(`/document/files`, checkFFixOpr)
      
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
    
  })
}

export const resetfileUpdate = () => (dispatch) => {
  dispatch({
    type: FILE_UPDATE_CLEAR,
  })
}

export const fileDelete = (fileId) => (dispatch) => {
  console.log('Invoked  Delete for ::', fileId)
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI.delete(`/document/users/${userDetail.user_id}/files/${fileId}`).then((response) => {
    let data = response.data.data

    dispatch({
      type: FILE_DELETE,
      payload: { data, operation: 'DELETE' },
    })
  })
}

export const resetfileDelete = () => (dispatch) => {
  dispatch({
    type: FILE_DELETE_CLEAR,
  })
}

// export const fileUpdateMydoc = (document) => (dispatch) => {
//   console.log("fileUpdateMydoc==Upload===>", document)
//   const userDetail = (encryptStorage.getItem('session-user'))
//   const data = {
//     user_id: `${userDetail.user_id}`,
//     company_id: `${userDetail.company_id}`,
//     "fileId": document.fileId,
//     "statusId": document.statusId,
//     "stage": "upload",
//     "storageType": "s3",

//     "format": "sample_protected_new.pdf",
//     "fileName": "",
//     "size": 73583,
//     "s3Path": "1422/e275bfe5-cd85-415b-a758-af1f1c39a6cd/source",
//     "randomId": "1665128596"

//   }
//   documentsAPI.put('/document/files', data).then((fileUpdateMydocResponse) => {
//     dispatch({
//       type: MYDOCUMENTS_UPLOADFILEUPDATE,
//       payload: fileUpdateMydocResponse.data,
//     })
//   })
// }

export const verifyFile = (document) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')

  ;(document.user_id = `${userDetail.user_id}`),
    (document.company_id = `${userDetail.company_id}`),
    documentsAPI.post('/document/check-file-version', document).then((fileUpdateMydocResponse) => {
      if (fileUpdateMydocResponse.data.data) {
        if (
          fileUpdateMydocResponse.data.data.uploadResponse ==
          'Duplicate file upload. You already have a version of this file.'
        ) {
          //$scope.sameVersionFiles.push({ 'fileName': fileUpdateMydocResponse.data.data.name })
          console.log(fileUpdateMydocResponse.data.data.uploadResponse)
          dispatch({
            type: FILE_UPLOAD_VERIFY,
            payload: {
              uuid: document.uuid,
              message: fileUpdateMydocResponse.data,
            },
          })
        } else if (response.data.data.uploadResponse == 'This file is already assigned to you.') {
          // assignee scenrio
          dispatch({
            type: FILE_UPLOAD_VERIFY,
            payload: {
              uuid: document.uuid,
              message: fileUpdateMydocResponse.data,
            },
          })
          //$scope.assignedFiles.push({ 'fileName': fileUpdateMydocResponse.data.data.name, 'user': fileUpdateMydocResponse.data.data.original_user})
        } else if (
          response.data.data.uploadResponse == 'You have assigned this file to someone already'
        ) {
          // original user scenrio
          //console.log(fileUpdateMydocResponse.data.data.uploadResponse);
          dispatch({
            type: FILE_UPLOAD_VERIFY,
            payload: {
              uuid: document.uuid,
              message: fileUpdateMydocResponse.data,
            },
          })
          //$scope.originalUserFiles.push({ 'fileName': fileUpdateMydocResponse.data.data.name , 'user': fileUpdateMydocResponse.data.data.assigned_user, 'permission': fileUpdateMydocResponse.data.data.permission})
        } else {
        }
      }
      console.log('Insert file here', document.fileId)
      if (document.fileId === undefined) dispatch(insertFile(document))
      else dispatch(updateFile(document))
      // dispatch({
      //   type: FILE_UPLOAD_VERIFY,
      //   payload: fileUpdateMydocResponse.data,
      // })
    })
}

export const insertFile = (document) => (dispatch) => {
  console.log('insert file')
  const userDetail = encryptStorage.getItem('session-user')

  let data = {
    fileName: document.file_name,
    company_id: `${userDetail.company_id}`,
    companyId: `${userDetail.company_id}`,
    startDate: new Date(),
    statusId: 2,
    size: document.size,
    format: document.file_name
      .slice(Math.max(0, document.file_name.lastIndexOf('.')) + 1)
      .toUpperCase(),
    stage: 'upload',
    createdBy: `${userDetail.user_id}`,
    randomId: document.uuid,
    storageType: 's3',
    s3Path: document.s3_path,
    user_id: `${userDetail.user_id}`,
  }

  documentsAPI
    .post('/document/files', data)
    .then((fileUpdateMydocResponse) => {
      console.log('File Entry Response', fileUpdateMydocResponse)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: fileUpdateMydocResponse.data.data, valid: true },
      })
    })
    .catch(function (error) {
      console.log('Error :', error)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: error.response.data.data, valid: false },
      })
    })
}

export const fileUploadLink = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI
    .post(`/document/fileuploadlinkgen2`, { company_id: userDetail.company_id })
    .then((response) => {
      dispatch({
        type: GET_S2_LINK,
        payload: response.data,
      })
    })
}

export const updateFile = (document) => (dispatch) => {
  console.log('insert file')
  const userDetail = encryptStorage.getItem('session-user')

  let data = {
    fileName: document.file_name,
    company_id: `${userDetail.company_id}`,
    companyId: `${userDetail.company_id}`,
    startDate: new Date(),
    statusId: 2,
    size: document.size,
    format: document.file_name
      .slice(Math.max(0, document.file_name.lastIndexOf('.')) + 1)
      .toUpperCase(),
    stage: 'upload',
    createdBy: `${userDetail.user_id}`,
    randomId: document.uuid,
    storageType: 's3',
    s3Path: document.s3_path,
    user_id: `${userDetail.user_id}`,
    fileId: document.fileId,
  }

  documentsAPI
    .put('/document/files', data)
    .then((fileUpdateMydocResponse) => {
      console.log('File Entry Response', fileUpdateMydocResponse)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: fileUpdateMydocResponse.data.data, valid: true },
      })
    })
    .catch(function (error) {
      console.log('Error :', error)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: error.response.data.data, valid: false },
      })
    })
}

export const getFileById = (files) => (dispatch) => {
  console.log('fileUpdateMydoc==getSingle===>', files.fileId)

  documentsAPI.get('/document/files/' + files.fileId).then((fileUpdateMydocResponse) => {
    console.log('Socket File updated :::', fileUpdateMydocResponse)
    dispatch({
      type: UPDATED_FILE,
      payload: fileUpdateMydocResponse.data,
    })
  })
}

export const resetShareDetails = () => (dispatch) => {
  dispatch({
    type: RESET_SHARE_DATA,
  })
}

export const resetTagDetails = () => (dispatch) => {
  dispatch({
    type: RESET_TAG_DATA,
  })
}

export const clearComplete = () => (dispatch) => {
  dispatch({
    type: MYDOCUMENT_MOVETOWIP_CLEAR,
  })
}

export const resetRevokeDetails = () => (dispatch) => {
  dispatch({
    type: MYDOCUMENTS_REVOKE,
    payload: undefined,
  })
}

export const clearReassignDetails = () => (dispatch) => {
  dispatch({
    type: MYDOCUMENTS_REASSIGN_CLEAR,
    payload: undefined,
  })
}

export const clearDeleteDetails = () => (dispatch) => {
  dispatch({
    type: MYDOCUMENTS_FILE_DELETE_CLEAR,
    payload: undefined,
  })
}

export const getUserNotifications = () => (dispatch) => {
  //console.log("fileUpdateMydoc==getSingle===>",files.fileId)

  documentsAPI
    .post('/document/get-user-notification', {
      user_id: encryptStorage.getItem('session-user').user_id,
    })
    .then((userNotification) => {
      console.log('Notification :::', userNotification)

      dispatch({
        type: USER_NOTIFICATION,
        payload: userNotification.data,
      })
    })
}

export const showFtpSftpLoader = (data) => (dispatch) => {
  dispatch({
    type: SHOW_FTP_SFTP_LOADER,
    payload: data,
  })
}

export const testConnection = (configDetails) => (dispatch) => {
  dispatch(showFtpSftpLoader(true))
  ftpSftpConfigAPI.post('/connection/test', configDetails).then((response) => {
    dispatch({
      type: TEST_CONNECTION,
      payload: response.data,
    })
  })
}

export const clearNotification = () => (dispatch) => {
  //console.log("fileUpdateMydoc==getSingle===>",files.fileId)

  documentsAPI
    .post('/document/update-user-notification', {
      user_id: encryptStorage.getItem('session-user').user_id,
    })
    .then((userNotification) => {
      console.log('Notification :::', userNotification)
      dispatch(getUserNotifications(encryptStorage.getItem('session-user').user_id))
    })
}

export const getFtpSftpDetails = (configDetails) => (dispatch) => {
  dispatch(showFtpSftpLoader(true))
  ftpSftpConfigAPI.post('/connection/get', configDetails).then((response) => {
    dispatch({
      type: GET_FTP_SFTP_CONFIG,
      payload: response.data,
    })
  })
}

export const createConnection = (configDetails) => (dispatch) => {
  dispatch(showFtpSftpLoader(true))
  ftpSftpConfigAPI.post('/connection/add', configDetails).then((response) => {
    dispatch({
      type: ADD_FTP_SFTP_CONFIG,
      payload: response.data,
    })
  })
}
export const updateConnection = (configDetails) => (dispatch) => {
  dispatch(showFtpSftpLoader(true))
  ftpSftpConfigAPI.put(`/connection/update/${configDetails.id}`, configDetails).then((response) => {
    dispatch({
      type: UPDATE_FTP_SFTP_CONFIG,
      payload: response.data,
    })
  })
}

export const removeToasterMsgProp = () => (dispatch) => {
  dispatch({
    type: REMOVE_TOASTER_MSG,
    payload: false,
  })
}

export const addUploadedFiles = (data) => (dispatch) => {
  console.log('addUploadedFiles invoked')
  dispatch({
    type: ADD_UPLOADED_FILES,
    payload: data,
  })
}

export const updateUploadProgress = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_UPLOAD_PROGRESS,
    payload: data,
  })
}
export const clearUploadProgress = () => (dispatch) => {
  dispatch({
    type: CLEAR_UPLOAD_PROGRESS,
  })
}


export const checkLicenseConsumption = (fileDetails, operation) => (dispatch) => {

  const userDetail = encryptStorage.getItem('session-user')
  usersAPI.get(
    '/user/' +
    `${userDetail.user_id}` + 
    '/subscription/' +
    `${operation}` +
    `/file/${fileDetails.fileId}`
  ).then((licenseResponse) => {
    
    licenseResponse.data.selectedFileId = fileDetails.fileId
    if(licenseResponse.data.success && (operation === 'check' || operation === 'fix')) {
      
      dispatch({
        type: LICENSE_CONSUMPTION_SUCCESS,
        payload: licenseResponse.data
      });

      dispatch(checkOrFix(fileDetails, operation));

    } else if(licenseResponse.data.success && operation === 'review'){

      (async () => {
        const responseFromFileUPdate = await  dispatch(fileUpdateReview(fileDetails.fileId, 7, "WIP"));

        if(responseFromFileUPdate.success && responseFromFileUPdate.data === "UPDATED") {
          const data = gotoDocEditor(fileDetails)
          dispatch({
            type: LICENSE_CONSUMPTION_SUCCESS,
            // payload: licenseResponse.data 
            payload: data
          }) 
        }else {
          console.log("ERORR", responseFromFileUPdate)
          console.log("ERROR2", licenseResponse)
          responseFromFileUPdate.selectedFileId = fileDetails.fileId
          dispatch({
            type: LICENSE_CONSUMPTION_REVIEW_FAILURE,
            // payload: licenseResponse.data,
            payload: responseFromFileUPdate,
          })
        }
      })();



    }else {

      dispatch({
        type: LICENSE_CONSUMPTION_FAILURE,
        payload: licenseResponse.data,
      })
    }

  })
}

export const resetConsumptionMessage = () => (dispatch) => {
  dispatch({
    type: LICENSE_MESSAGE_CLEAR,
  })
}
export const resetCheckFixMessage = () => (dispatch) => {
  dispatch({
    type: CHECK_FIX_OPR_FAIL_CLEAR,
  })
}


export const resetReviewMessage = () => (dispatch) => {
  dispatch({
    type: LICENSE_CONSUMPTION_REVIEW_FAILURE_CLEAR
  })
}